import { ExporttocsvService, csvDate } from '../../services/exporttocsv/exporttocsv.service';
import {Component, Input, OnChanges, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Dictionary} from 'highcharts';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-reconciliation-apilog',
    templateUrl: './reconciliation-apilog.component.html',
    styleUrls: ['./reconciliation-apilog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReconciliationApilogComponent implements OnInit, OnChanges {

  @Input() info: any;
  columnsToDisplay = ['date', 'method', 'endpoint', 'member', 'body', 'responsecode'];
  public items = new MatTableDataSource<Dictionary<any>>();
  public form: UntypedFormGroup;


  exportCsv(title: string): void {
    this.csvExport.exportTable(title, this.items, {
      "date": {header: "Date", value: (item: any) => csvDate(item.createdAt, 'mediumDate')},
      "method": {header: "Method", value: (item: any) => item.method},
      "endpoint": {header: "Endpoint", value: (item: any) => item.apiCalled},
      "member": {header: "Sender", value: (item: any) => item.sender},
      "body": {header: "Body", value: (item: any) => item.request.body},
      "responsecode": {header: "Response Code", value: (item: any) => item.responseCode},
    }, this.columnsToDisplay, {exclude: ['action', 'actionmenu']});
  }

  constructor(
      private formBuilder: UntypedFormBuilder,
      private csvExport: ExporttocsvService
  ) {
    this.form = this.formBuilder.group({
    });
  }

  ngOnInit(): void {
    this.loadItems();
  }

  ngOnChanges(): void {
    this.loadItems();
  }

  private loadItems(): void {
    this.items.data = this.info.apiLogTransactions;
    this.items.data?.forEach(item => {
      item.request.body = JSON.stringify(item.request.body);
      const thisMember = this.info.members.find((member: any) => member.id === item.userId);
      item.sender = (thisMember?.firstName || '') + ' ' + (thisMember?.lastName || '');
    });
  }

}
